const instrumentFormData = trackId => ({
  title: `${trackId.split('-')[0].trim()} Annotation`,
  completed: false,
  'Instrument Function': [],
  Texture: [],
  Voicing: [],
  'Rhythm Density': [],
  'Rhythm Description': '',
  'Secondary Melody Categorization': [],
  'String Articulation Techniques': [],
  'Articulation Techniques': '',
  'Effects Of Articulation': '',
  'Melody Description': '',
  Technique: '',
  Dynamics: '',
});

const emptyFormData = trackId => {
  if (trackId === 'music-structure-track') return {
    section_name: '',
    rhythmic_style: '',
    harmonic_progression_verbal_description: '',
    section_description: '',
  };
  if (trackId === 'chord-track') return {
    sharp_flat: '',
    note: '',
    chord_type: '',
    bass_sharp_flat: '',
    bass_note: '',
  };
  if (trackId.includes('track')) return instrumentFormData(trackId);
  return { title: 'New Annotation' };
};

const fallbackColorType = trackId => {
  const normalized = trackId.toLowerCase();
  if (normalized === 'chord-track') return 'chord';
  if (normalized.includes('piano')) return 'piano';
  if (normalized.includes('pad')) return 'pad';
  if (normalized.includes('drum')) return 'drum';
  return 'pad';
};

export const createAnnotationBlockDefaults = ({
  trackId,
  trackInfo,
  trackAnnotations = [],
}) => ({
  ...(trackInfo?.fullInstrumentPath && { fullInstrumentPath: trackInfo.fullInstrumentPath }),
  formData: emptyFormData(trackId),
  colorType: trackAnnotations.find(annotation => annotation.colorType)?.colorType
    || fallbackColorType(trackId),
});
